// Polyfill for fetch
import 'whatwg-fetch'

// Polyfill for global
if (typeof global === 'undefined') {
  window.global = window
}

// Simple EventEmitter implementation for browser compatibility
class EventEmitter {
  constructor () {
    this.events = {}
  }

  on (event, listener) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(listener)
    return this
  }

  emit (event, ...args) {
    if (this.events[event]) {
      this.events[event].forEach(listener => listener(...args))
    }
    return this
  }

  removeListener (event, listenerToRemove) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter(listener => listener !== listenerToRemove)
    }
    return this
  }

  removeAllListeners (event) {
    if (event) {
      delete this.events[event]
    } else {
      this.events = {}
    }
    return this
  }
}

// Make EventEmitter available globally
if (typeof window !== 'undefined') {
  window.EventEmitter = EventEmitter
}
